import axios, { AxiosResponse } from 'axios'
import { IUserModel } from './UserModel'
import { ApiResponse, PageResponse } from '../../../../shared/models/ApiModels'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const USER_CREATE_URL  = `${API_URL}api/v1/user/create`
export const USER_GET_ALL_URL = `${API_URL}api/v1/user/users`
export const USER_DELETE_URL  = `${API_URL}api/v1/user/delete/`
export const USER_UPDATE_URL  = `${API_URL}api/v1/user/`
export const USER_GET_BY_ID_URL  = `${API_URL}api/v1/user/`
export const USER_ROLES_URL     = `${API_URL}api/v1/user/role/roles`

export function createUser(user: IUserModel) {
  return axios.post(USER_CREATE_URL, user)
}

export function updateUser(user: IUserModel) {
  return axios.put(USER_UPDATE_URL + user.id, user)
}

export function deleteUser(id: string) {
  return axios.post(USER_DELETE_URL + id)
}

export async function loadUsers(
  page = 0,
  size = 10,
  sort = 'createdDate',
  order = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<IUserModel>>>> {
  return axios.get(USER_GET_ALL_URL, { params: { page, size, sort, order } })
}

export async function loadUser(userId: string): Promise<AxiosResponse<ApiResponse<IUserModel>>> {
  return axios.get(USER_GET_BY_ID_URL + userId)
}

export async function loadUserRoles(): Promise<AxiosResponse<ApiResponse<PageResponse<any>>>> {
  return axios.get(USER_ROLES_URL)
}
